import type { LocationConfigRow } from 'api/recoveryAi.types'
import type { Fields as OrmLocation } from 'models/Location'

type Translate = (key: string, replacements?: Record<string, any>) => string

/**
 * AI-1173 follow-up: resolve the display name for a location-configs row.
 * Named rows pass through untouched. A row whose configured `name` is blank
 * (a null/blank wire name coalesces to '' at the API boundary) prefers
 * "Unnamed location (<street>)" when the Redux-ORM Location record for this
 * id carries a non-blank street address — GET recovery/location_configs has
 * no address fields of its own, so the ORM (loaded by the scene, keyed by the
 * same location id) is the only source for it — and falls back to the plain
 * "Unnamed location" copy when there's no matching ORM row, or its street is
 * itself blank.
 *
 * Shared by useActiveLocationsController and useWizardLocations so the
 * address-vs-plain-fallback branch lives in exactly one place.
 */
export function locationDisplayName(
  row: LocationConfigRow,
  ormLocation: OrmLocation | undefined,
  t: Translate
): string {
  if (row.name.trim() !== '') return row.name

  const address = ormLocation?.street?.trim()
  return address
    ? t('unnamed_location_with_address', { address })
    : t('unnamed_location')
}
